package br.com.heyagenda.web

import dev.gitlive.firebase.FirebaseOptions
import kotlinx.browser.window

object WebFirebaseConfig {

    /**
     * Determines whether the current web session is running in the Development environment.
     * Rule:
     * - Hostname is dev.heyagenda.com.br (or starts with dev.)
     * - Hostname is localhost or 127.0.0.1 (local development testing)
     * - Query param ?env=dev is present
     */
    fun isDevEnvironment(): Boolean {
        val hostname = window.location.hostname.lowercase()
        val search = window.location.search.lowercase()

        return hostname == "dev.heyagenda.com.br" ||
                hostname.startsWith("dev.") ||
                hostname.contains("localhost") ||
                hostname.contains("127.0.0.1") ||
                search.contains("env=dev")
    }

    /**
     * Returns the FirebaseOptions matching the detected environment:
     * - Dev (dev.heyagenda.com.br): heyagenda-dev-3f199
     * - Prod (heyagenda.com.br): heyagenda-65564
     */
    fun getFirebaseOptions(): FirebaseOptions {
        return if (isDevEnvironment()) {
            FirebaseOptions(
                applicationId = "1:520409193243:web:heyagenda-dev-web",
                apiKey = "AIzaSyCCQTUMXIhkcksNlfYvZxNMkP5XUJSWFQY",
                projectId = "heyagenda-dev-3f199",
                storageBucket = "heyagenda-dev-3f199.firebasestorage.app",
                gcmSenderId = "520409193243",
                authDomain = "heyagenda-dev-3f199.firebaseapp.com"
            )
        } else {
            FirebaseOptions(
                applicationId = "1:220313808476:web:heyagenda-prod-web",
                apiKey = "AIzaSyChJnuGlUvtJg9nOXrX0t0_ULTBHha5o88",
                projectId = "heyagenda-65564",
                storageBucket = "heyagenda-65564.firebasestorage.app",
                gcmSenderId = "220313808476",
                authDomain = "heyagenda-65564.firebaseapp.com"
            )
        }
    }
}
